import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ScalarResponseModel } from "../../models/scalar/scalar.model";

@Injectable({
    providedIn: 'root'
})
export class missedPayloadsCountService {

    private MISSEDPAYLOADSCOUNT_URL = 'api/missedPayloadsCount/{historyDays}/{silentDays}'

    constructor(
        private _httpClient: HttpClient
    ) {
    }

    get url(): string {

        return this.MISSEDPAYLOADSCOUNT_URL;
    }

    getTankData$(historyDays: string, silentDays: string ): Observable<ScalarResponseModel> {
        let x = this.url.replace('{historyDays}', historyDays);
        let y = x.replace('{silentDays}', silentDays);
        return this._httpClient.get<ScalarResponseModel>(`${y}`);
    }
}
